import { Table } from "../components/table-pagination-sorting/components/Table"
import { useEffect, useRef, useState } from 'react';
import { PaginatingAndSortingProps } from "../components/table-pagination-sorting/interfaces/interfaces";
import { useDoneFetchActions } from "../hooks/useDoneFetchActions";
import { getPesoById, getPesos, savetPeso } from "../services/pesosServices";
import { propsPeso, tablePaginationRs } from "../utils/formsInitialsStates";
import { Modals } from "../components/Modals";
import { PesoForm, PesoSubmitValues } from "../components/forms-modals/PesoForm";
import { useAppDispatch } from "../store/store";
import { showMessage } from "../reducers/msgReducer";
import { dateToInput, getColorByStatusPeso } from "../utils/utility";
import { PlantaFechaFilterProps, PlantaFechas } from "../components/others/Filters/PlantaFechas";




export const Pesos = () => {

  const doneFetchActions = useDoneFetchActions();
  const dispatch = useAppDispatch();
  const [datosPeso, setDatosPeso] = useState({} as { on: string, data: propsPeso | undefined })
  const pesoFormRef = useRef<{ handleClick: () => PesoSubmitValues | undefined; resetForm: () => void; }>();
  const [data, setData] = useState({ count: 0 } as { count: number; rows: Array<{ [key: string]: any }>; info?: any });

  const [filterData, setDataFilter] = useState({ fechaIni: dateToInput(), fechaFin: dateToInput(), limit: 255 } as filtersProps);
  interface filtersProps extends PaginatingAndSortingProps, PlantaFechaFilterProps {
    render: number;
  }

  useEffect(() => {
    function searchDataPeso(tipe: string, id: number) {
      doneFetchActions(getPesoById(id)).then((resp: propsPeso) => {
        setDatosPeso({ on: tipe, data: resp });
      })
    }
    doneFetchActions(getPesos(filterData)).then((data: tablePaginationRs) => {
      data.rows = data.rows?.map(ob => ({
        ...ob,
        actions: <>
          <button
            className={`btn ${getColorByStatusPeso(ob.tipo_estado)}`}
            onClick={() => searchDataPeso("edit", ob.id)}
          ><span className="icon-pencil"></span></button>
        </>
      }))
      setData(data)
    })
  }, [filterData, doneFetchActions])


  const onSaveModal = () => {
    const pesoValues = pesoFormRef.current?.handleClick();
    if (pesoValues) {
      doneFetchActions(savetPeso(pesoValues)).then(resp => {
        dispatch(showMessage({
          isShow: true,
          title: resp.message || "Litros registrados con éxito",
          type: 'success'
        }))
        setDataFilter(ob => ({ ...ob, render: ob.render + 1 }));
        pesoFormRef.current?.resetForm();
        if (datosPeso.on === "edit") {
          setDatosPeso({ on: '', data: undefined })
        }
      })
    }
  }
  const onCloseModal = () => {
    pesoFormRef.current?.resetForm();
    setDatosPeso({ on: '', data: undefined })
  }
  const handleSubmit = (dataFilter: PlantaFechaFilterProps) => {
    console.log(dataFilter)
    setDataFilter((dt) => ({ ...dt, ...dataFilter }));
  }
  const handleChangeTable = (pageAction: PaginatingAndSortingProps) => {
    setDataFilter((dt) => ({ ...dt, ...pageAction }));
  }

  function downReport(type: string) {
    doneFetchActions(getPesos(filterData, type))
  }

  const titles = [
    { title: "Cupo", sort: "Cupo.codigo" },
    { title: "Proveedor", sort: "Proveedor.cedula" },
    /* { title: "Peso de Entrada (Kg)", sort: "peso_entrada_kg" },
    { title: "Peso Salida (kg)", sort: "peso_salida_kg" }, */
    { title: "Litros", sort: "cantidad" },
    { title: "Deposito", sort: "Tina.nombre_tina" },
    { title: "Comentario", sort: "comentario" },
    { title: "Fecha", sort: "fecha" },
    { title: "Acciones", name: 'actions', sort: "tipo_estado" }
  ]

  return (
    <div>
      <div className="d-flex justify-content-center pt-4">
        <h4 className="align-self-end">Pesos por día</h4>
      </div>
      <div className="d-flex justify-content-center pt-4">
        <PlantaFechas runSearch={handleSubmit} initialValuesFilter={filterData} 
        hideIntervalo={true} /* Evidelis lo colocó - Esto asegura que no se muestre el selector de intervalo en esta página*/ /> 
        
      </div>
      <div className="d-flex justify-content-end pb-4 gap-2">
        <button onClick={() => downReport('pdf')} className='btn btn-danger mb-4'>PDF</button>
        <button onClick={() => downReport('calidad')} className='btn btn-danger mb-4'>PDF de Calidad</button>
        <button onClick={() => downReport('csv')} className='btn btn-warning mb-4'>CSV</button>
        <button onClick={() => { setDatosPeso({ on: "add", data: undefined }); }} type="button" className="btn btn-primary btn-rounded mb-4" >
          Nuevo Peso
        </button>
      </div>
      <div>
      </div>
      <h5 className="text-end bg-secondary rounded-3 px-4 py-1 text-white">Total de Litros: {data.info?.pesajeTotal || '0.0'}</h5>
      <Table dataTable={{ ...data, titles }} onChange={handleChangeTable} />
      <Modals title="Peso" show={!!datosPeso.on} onSave={onSaveModal} onClose={onCloseModal}>
        <PesoForm ref={pesoFormRef} data={datosPeso.data} on={datosPeso.on} />
      </Modals>
    </div>
  )
}
